import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ContactsImportPage } from './contacts-import';

@NgModule({
  declarations: [
    ContactsImportPage
  ],
  imports: [
    IonicPageModule.forChild(ContactsImportPage)
  ],
  exports: [
    ContactsImportPage
  ],
  entryComponents: [
    ContactsImportPage
  ]
})
export class ContactsImportModule {}



// WEBPACK FOOTER //
// ./src/pages/contacts-import/contacts-import.module.ts